import { CommonModule } from '@angular/common';
import { Component, Input, AfterViewInit, ChangeDetectionStrategy, ElementRef, ViewChild } from '@angular/core';
import { IconComponent } from '@mode/capra';
import { GoogleSheetUploadFacade } from '@mode/dataset/google/contract';
import { AnalyticsEvent, AnalyticsService, RunMethodType } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-explore-connect-mode-db',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './explore-connect-mode-db.component.html',
  styleUrls: ['./explore-connect-mode-db.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExploreConnectModeDbComponent {
  @Input({ required: true }) flowType = '';
  @Input({ required: true }) linkDest = '';
  @Input() orgId?: number;
  @ViewChild('linktext') link: ElementRef | undefined;

  constructor(
    private uploadSheetFacade: GoogleSheetUploadFacade,
    private analyticsService: AnalyticsService
  ) {}

  ngAfterViewInit(): void {
    if (this.link) {
      this.trackLink(this.link);
    }
  }

  private trackLink(linkElement: ElementRef): void {
    this.analyticsService.run(
      RunMethodType.TrackLink,
      linkElement.nativeElement,
      AnalyticsEvent.Name.SkippedDBConnectionSignUpStep,
      {
        orgId: this.orgId,
      }
    );
  }

  goToGoogleSheet(): void {
    this.uploadSheetFacade.launchDialog();
  }
}
